import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, MenuItem, Paper, Radio, RadioGroup, TextField, Typography } from '@material-ui/core'
import { DataGrid } from '@material-ui/data-grid'
import { Autocomplete } from '@material-ui/lab'
import React, { useEffect, useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import { useFeedback } from '../../../components/Feedback'
import { CoachCampAPI, getCourseCollection, listCourse, PushAPI } from '../../../utils/api'
import moment from 'moment'
const PushTypeName: { [key: string]: string } = {
    'vip': '会员介绍',
    'initialInterview': '首次约谈',
    'course': '课程',
    'collection': '合辑',
    'coachCamp': '训练营',
    'groupCoaching': '团体教练',
    'coaching': '一对一教练',
}

const Push = () => {
    const { data: pushFlow, refetch } = useQuery(['listpushflow'], () => PushAPI.list())
    const { data: courses } = useQuery(['listcourse'], () => listCourse())
    const { data: collections } = useQuery(['listcollection'], () => getCourseCollection())
    const { data: coachCamps } = useQuery(['listcoachcamp'], () => CoachCampAPI.list())
    const { showDialog, showLoading, showToast, hideLoading } = useFeedback()
    const [contentType, setContentType] = useState('')
    const [push, setPush] = useState({
        title: '',
        content: ''
    })
    const [content, setContent] = useState<{
        value: string,
        label: string,
    } | null>(null)
    const [coachCamp, setCoachCamp] = useState<{
        value: string,
        label: string,
    } | null>(null)
    const [createPush, setCreatePush] = useState(false)
    const [pushRange, setPushRange] = useState({
        vip: 0,
        initialInterview: 0,
        enrollCoachCamp: 0,
    })
    const needChooeseContent = () => {
        return ['course', 'collection', 'coachCamp'].includes(contentType)
    }
    useEffect(() => {
        setContent(null)
    }, [contentType])
    const coachCampsOption = useMemo(() => {
        if (!coachCamps) {
            return []
        }
        console.info(coachCamps)
        return coachCamps.data.map(c => ({
            label: c.name,
            value: `${c.id}`
        }))
    }, [coachCamps])
    const contentList = useMemo(() => {
        if (contentType === 'course') {
            if (!courses) {
                return []
            }
            return courses.map(c => ({
                label: c.name,
                value: `${c.id}`
            }))
        } else if (contentType === 'collection') {
            if (!collections) {
                return []
            }
            return collections.map(c => ({
                label: c.name,
                value: `${c.id}`
            }))
        } else if (contentType === 'coachCamp') {
            return coachCampsOption
        }
        return []
    }, [contentType, courses, collections, coachCampsOption])

    const handleCreatePush = () => {
        if (!push.title) {
            showToast('请输入推送标题');
            return;
        }
        if (!push.content) {
            showToast('请输入推送文案');
            return;
        }
        if (!contentType) {
            showToast('请选择推送内容')
            return;
        }
        if (needChooeseContent() && !content) {
            showToast('请选择' + PushTypeName[contentType])
            return;
        }
        if (pushRange.enrollCoachCamp && !coachCamp) {
            showToast('请选择训练营')
            return;
        }

        showLoading('推送中...')
        PushAPI.create(push.title, push.content, contentType, content, { ...pushRange, coachCamp }).then(res => {
            hideLoading()
            showToast('推送成功')
            refetch()
            setCreatePush(false)
        }).catch(e => {
            hideLoading()
            showToast('推送失败')
        })
    }
    const parseRange = (range: any) => {
        const strs: string[] = []
        console.info(range)
        if (range.vip) {
            if (range.vip === 1) {
                strs.push('VIP会员')
            } else if (range.vip === 2) {
                strs.push('普通会员')
            }
        }
        if (range.initialInterview) {
            if (range.initialInterview === 1) {
                strs.push('进行过首次约谈')
            } else if (range.initialInterview === 2) {
                strs.push('未进行过首次约谈')
            }
        }
        if (range.enrollCoachCamp) {
            if (range.enrollCoachCamp === 1) {
                strs.push('报名' + range.coachCamp.label)
            } else if (range.enrollCoachCamp === 2) {
                strs.push('未报名' + range.coachCamp.label)
            }
        }
        return strs.join(',')
    }
    return <>
        <Box display="flex" justifyContent="space-between">
            <Box>
                <Typography variant="h6">营销推送</Typography>
            </Box>
            <Box>
                <Button onClick={() => setCreatePush(true)}>新建推送</Button>
            </Box>
        </Box>
        <Box mt={2}>
            <Paper>
                <DataGrid autoHeight hideFooter columns={[
                    { field: 'title', headerName: "推送标题", width: 200 },
                    { field: 'content', headerName: '推送文案', width: 200 },
                    {
                        field: 'push_type', headerName: '推送类型', width: 160, valueFormatter: param => {
                            return PushTypeName[param.value as string]
                        }
                    },
                    {
                        field: 'push_content', headerName: '推送内容', width: 200, valueFormatter: param => {
                            const v = (param.value as any)
                            return v ? JSON.parse(v).label : '-'
                        }
                    },
                    {
                        field: 'push_range', headerName: '推送人群', width: 320, resizable: true, valueFormatter: param => {
                            return parseRange(JSON.parse(param.value as string))
                        }
                    },
                    { field: 'push_count', headerName: '推送数量', width: 140, align: 'center' },
                    {
                        field: 'create_time', headerName: '推送时间', width: 200, valueFormatter: (params) => {
                            return moment(params.value as number).format('YYYY-MM-DD HH:mm:ss')
                        }
                    },
                ]} rows={pushFlow ? pushFlow : []} />
            </Paper>
        </Box>
        <Dialog open={createPush} maxWidth="sm" fullWidth onClose={() => setCreatePush(false)}>
            <DialogTitle>
                新建推送
            </DialogTitle>
            <DialogContent>
                <Box>
                    <TextField value={push.title} onChange={e => setPush({ ...push, title: e.target.value })} fullWidth label="推送标题" variant="outlined" size="small" />
                </Box>
                <Box mt={2}>
                    <TextField value={push.content} onChange={e => setPush({ ...push, content: e.target.value })} fullWidth label="推送文案" multiline rows={3} rowsMax={3} variant="outlined" size="small" />
                </Box>
                <Box mt={2}>
                    <TextField select value={contentType} onChange={e => setContentType(e.target.value)} fullWidth label="选择推送内容" variant="outlined" size="small">
                        {Object.keys(PushTypeName).map(k => <MenuItem value={k}>{PushTypeName[k]}</MenuItem>)}
                    </TextField>
                </Box>
                {needChooeseContent() && <Box mt={2}>
                    <Autocomplete
                        options={contentList}
                        value={content}
                        getOptionLabel={(option) => option.label}
                        onChange={(e, v) => setContent(v)}
                        renderInput={(params) => <TextField {...params} label={`选择${PushTypeName[contentType]}`} size="small" variant="outlined" />}
                    />
                </Box>}
                <Box mt={2}>
                    <Typography variant="subtitle1">推送人群</Typography>
                    <Box mt={1}>
                        <FormControl>
                            <FormLabel>
                                是否是会员
                            </FormLabel>
                            <RadioGroup row value={pushRange.vip} onChange={e => setPushRange({ ...pushRange, vip: +e.target.value })}>
                                <FormControlLabel label="不限制" value={0} control={<Radio size="small" color="secondary" />} />
                                <FormControlLabel label="VIP会员" value={1} control={<Radio size="small" color="secondary" />} />
                                <FormControlLabel label="普通会员" value={2} control={<Radio size="small" color="secondary" />} />
                            </RadioGroup>
                        </FormControl>

                    </Box>
                    <Box mt={1}>
                        <FormControl>
                            <FormLabel>
                                是否进行过首次约谈
                            </FormLabel>
                            <RadioGroup row value={pushRange.initialInterview} onChange={e => setPushRange({ ...pushRange, initialInterview: +e.target.value })}>
                                <FormControlLabel name="initialInterview" label="不限制" value={0} control={<Radio size="small" color="secondary" />} />
                                <FormControlLabel name="initialInterview" label="进行过首次约谈" value={1} control={<Radio size="small" color="secondary" />} />
                                <FormControlLabel name="initialInterview" label="未进行过首次约谈" value={2} control={<Radio size="small" color="secondary" />} />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                    <Box mt={1}>
                        <FormControl>
                            <FormLabel>
                                是否报名过某一期训练营
                            </FormLabel>
                            <RadioGroup row value={pushRange.enrollCoachCamp} onChange={e => setPushRange({ ...pushRange, enrollCoachCamp: +e.target.value })}>
                                <FormControlLabel name="initialInterview" label="不限制" value={0} control={<Radio size="small" color="secondary" />} />
                                <FormControlLabel name="initialInterview" label="已报名" value={1} control={<Radio size="small" color="secondary" />} />
                                <FormControlLabel name="initialInterview" label="未报名" value={2} control={<Radio size="small" color="secondary" />} />
                            </RadioGroup>
                        </FormControl>
                        {pushRange.enrollCoachCamp !== 0 && <Box mt={2}>
                            <Autocomplete

                                options={coachCampsOption}
                                value={coachCamp}
                                getOptionLabel={(option) => option.label}
                                onChange={(e, v) => setCoachCamp(v)}
                                renderInput={(params) => <TextField {...params} label="选择训练营" size="small" variant="outlined" />}
                            />
                        </Box>}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="text" onClick={() => setCreatePush(false)}>取消</Button>
                <Button onClick={handleCreatePush}>推送</Button>
            </DialogActions>
        </Dialog>
    </>
}

export default Push